// extracted by mini-css-extract-plugin
var _1 = "FormFields-modulecheckboxLabel__kaiqj";
var _2 = "FormFields-modulecheckboxLabelTitle__w7xSj";
export { _1 as "checkboxLabel", _2 as "checkboxLabelTitle" }
